import API from "./API";

// seo Get Api
export const getSeoSubCategoryAPI = async (payload, hostname) => {
    try {
        const response = await API.get(`/seopages/subcategories/${payload}`, { headers: payload });
        return response;
    }
    catch (error) {
        if (error?.response?.data?.message === "No value present") {
            return error?.response?.data;
        }
        throw error;
    }
};
export const getSeoSubSubCategoryAPI = async (payload, hostname) => {
    try {
        const response = await API.get(`/seopages/subsubcategories/${payload}`, { headers: payload });
        return response;
    }
    catch (error) {
        if (error?.response?.data?.message === "No value present") {
            return error?.response?.data;
        }
        throw error;
    }
};

// Prospective seo Get Api
export const getProspectiveSeoSubCategoryAPI = async (payload, hostname) => {
    try {
        const response = await API.get(`/programmatic-pages/subcategories/${payload}`, { headers: payload });
        return response;
    }
    catch (error) {
        if (error?.response?.data?.message === "No value present") {
            return error?.response?.data;
        }
        throw error;
    }
};

// Prospective seo Get Api
export const getProspectiveSeoSubSubCategoryAPI = async (payload, hostname) => {
    try {
        const response = await API.get(`/programmatic-pages/subsubcategories/${payload}`, { headers: payload });
        return response;
    }
    catch (error) {
        if (error?.response?.data?.message === "No value present") {
            return error?.response?.data;
        }
        throw error;
    }
};